import React, { useState, useContext, useEffect } from 'react';
import { Link, useParams } from "react-router-dom";
import * as htmlToImage from 'html-to-image';
import saveAs from '../save';
import { AppContext } from './../AppContext'; 

import DropDown from './../_components/DropDown/DropDown.js';
import Canvas from './../_components/Canvas/Canvas.js';
import Controls from './../_components/Controls/Controls.js';


function ControlsMacro() {
	const { jkLocalStorage, template, theme, themes } = useContext(AppContext);
	
	return (
		<Controls modifier={"left"}>
			<div>
				<Link to={`/`} class="material-icons">home</Link>
			</div>
			<div>
				<DropDown label={ `${themes[theme].target}` }>
					{themes.map( (item, i) => 
						<li 
							key={i} 
							class={ (theme == i) ? 'on' : 'off' }
						><Link to={`/editor/${i}/0`}>{ `${item.target}` }</Link></li>
					)}
				</DropDown>
			</div>
			<div>
				<DropDown label={ `${themes[theme].templates[template].label}` }>
					{themes[theme].templates.map( (item, i) => 
						<li 
							key={i} 
							class={ (template == i) ? 'on' : 'off' }
						><Link to={`/editor/${theme}/${i}`}>{ `${item.label}` }</Link></li>
					)}
				</DropDown>
			</div>
			<div>
					{ (global.localStorage.key(0)) &&
					<button class="_tertiary" onClick={ ()=> jkLocalStorage("reset") }>Revert to Defaults</button>
				}
			</div>
		</Controls>
	)
}
function ClipboardButton() {
	const { handleCopy2Clipboard } = useContext(AppContext);
	const [message, setMessage] = useState("Copy to Clipboard");
	let handleClick = () => {
		handleCopy2Clipboard('Canvas');
		setMessage("Copied!");
		const myTimeout = setTimeout(() => setMessage("Copy to Clipboard"), 5000);
	}
	return (
		<a 	onClick={()=>handleClick('')} 
			class={`ClipboardButton ${message == 'Copied!' ? 'off' : 'on' }`}
			disabled={ message == 'Copied!' ? true : false }
		>{ message }</a>
	)
}
function ControlsMicro() {
	const { 
		jkLocalStorage, 
		template, 
		gradient, 
		setGradient, 
		colors, 
		theme, 
		themes, 
		handleColor, 
		handleSave, 
		handleCopy2Clipboard } = useContext(AppContext);
	
	return (
		<Controls>
			<div>
				<ul class="Styles">
					{ themes[theme].templates[template].colors.length != 0 && 
						<>
							<li>
								Background 
							</li>
							{ themes[theme].templates[template].colors.map( (item, val) =>
								<li key={val}>
									<input type="color" defaultValue={ colors[val] } onChange={ (e) => handleColor(e, val)} />
									<label style={{ background: `${colors[val]}` }}/>
								</li>
							)}
						</>
					}
				</ul>
			</div>
			{ themes[theme].templates[template].colors.length > 1 &&
				<div style={{ width: '100%'}}>
					<ul class="Styles">
						<li>
							<button class={`ButtonToggle ${!gradient ? 'no' : 'yes' }`} onClick={ ()=> setGradient(!gradient) }></button>
						</li>
						<li>{`${!gradient ? 'Edge' : 'Gradient' }`}</li>
					</ul>
				</div>
			}
			<div>
				<ClipboardButton />
				<button onClick={()=>handleSave('Canvas', `${themes[theme].target}-${themes[theme].templates[template].css}.png`)}>Download</button>
			</div>
		</Controls>
	)
}



function Editor() {	
	const { themes } = useContext(AppContext);
	
	const [specs, setSpecs] = useState();
	const [colors, setColors] = useState([]);
	const [textArray, setTextArray] = useState();
	
	const [theme, setTheme] = useState(0);
	const [template, setTemplate] = useState(0);
	const [gradient, setGradient] = useState(true);
	
	const { themeID, templateID } = useParams();
	
	useEffect(() => {
		updateView();
	},[themeID, templateID]);
	
	useEffect(() => {
		jkLocalStorage('text',themes[theme].templates[template].text,`${themes[theme].id}.${themes[theme].templates[template].css}.text`);
		jkLocalStorage('colors', themes[theme].templates[template].colors);
	}, [theme, template]);
	
	let updateView = () => {
		setTheme(themeID);
		setTemplate(templateID);
		setColors(themes[themeID].templates[templateID].colors);
		setTextArray(themes[themeID].templates[templateID].text);
	}
	
	let jkLocalStorage = (setting, value, key) => {
		if (setting === 'reset') {
			global.localStorage.clear();
			jkLocalStorage('text',themes[theme].templates[template].text, `${themes[theme].id}.${themes[theme].templates[template].css}.text`);
			updateView();
		}
		if (setting === 'colors') {
			if(!global.localStorage.getItem('colors')) {
				// empty, set default value
			  	setColors(value);
			} else {
				// exists, populate from localstorge
				setColors([...global.localStorage.getItem('colors').split(',')]);
			}
		}
		if (setting === 'text') {
			if(!global.localStorage.getItem(key)) {
			  	setTextArray(value);
			} else {
			  	setTextArray([...global.localStorage.getItem(key).split(',')]);
			}
		}
	}
	let handleTextArray = (e, ref, newValue) => {
		let _str = `${themes[theme].id}.${themes[theme].templates[template].css}.text`;
		let _textArray = [... textArray];
		_textArray[ref] = e.target.innerHTML;
		setTextArray(_textArray);
		global.localStorage.setItem(_str, _textArray);
	}
	let handleColor = (e, ref) => {
		let _settings = [... colors];
		_settings[ref] = e.target.value;
		setColors(_settings);
		global.localStorage.setItem('colors', _settings);
	}
	let handleCopy2Clipboard = (id) => {
		const fontEmbedCss = htmlToImage.getFontEmbedCSS(document.getElementById(id));
		htmlToImage.toBlob(document.getElementById(id), 
			{
				width: themes[theme].specs.width,
				height: themes[theme].templates[template].height || themes[theme].specs.height,
				pixelRatio: 1
			})
			.then(function (blob) {
				navigator.clipboard.write([
					new window.ClipboardItem({ "image/png": blob })
					
				]);
		});
	}
    let handleSave = (id, fileName) => {
		const fontEmbedCss = htmlToImage.getFontEmbedCSS(document.getElementById(id));
		htmlToImage.toPng(document.getElementById(id), 
			{
				width: themes[theme].specs.width,
				height: themes[theme].templates[template].height || themes[theme].specs.height,
				pixelRatio: 1
			})
			.then(function (dataUrl) {
				saveAs(dataUrl, fileName);
				
		});
    }
	
	return (
		<AppContext.Provider
			value={{
			theme,
			themes,
			template,
			colors,
			handleColor,
			gradient,
			setGradient,
			textArray, 
			handleTextArray, 
			handleSave,
			handleCopy2Clipboard,
			jkLocalStorage
		}}>
			<div class="Main">			
				<ControlsMacro/>
				<Canvas/>
				<ControlsMicro/>
			</div>
		</AppContext.Provider>
	);
}

export default Editor;
